import { render } from "./MdvHeader.vue?vue&type=template&id=0755b811&scoped=true"
import script from "./MdvHeader.vue?vue&type=script&lang=js"
export * from "./MdvHeader.vue?vue&type=script&lang=js"

import "./MdvHeader.vue?vue&type=style&index=0&id=0755b811&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\mdv-webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0755b811"]])

export default __exports__